import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getSelected = state => state.UserOrgSiteReducer.selected;

function* deleteIncidentSaga({ payload }) {
    try {

        if (payload.length === 0){
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: `You need to choose incident first!`,
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
            return;
        }

        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.DELETE_INCIDENT,
            data: {
                organization: selected.org,
                items: payload.map(item => item.id)
            }
        });

        if (apiResponse.res.data.response === 200) {
            // SUCCESS
            yield put({ type: ActionTypeConstants.DELETE_INCIDENT_SUCCESS });
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: `Incident${payload.length > 1 ? 's' : ''} deleted!`,
                    color: "success"
                }
            });
            yield put({ type: ActionTypeConstants.LOAD_INCIDENTS });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "An issue occurred while deleting incident",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });    
        }

    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "An issue occurred while deleting incident",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.DELETE_INCIDENT, deleteIncidentSaga);
}
